import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/OrderSelection.css';

const OrderSelection = () => {
  const { addressId } = useParams();
  const [order, setOrder] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');
  const [paymentError, setPaymentError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/orders/create/${addressId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => setOrder(response.data))
      .catch(() => setPaymentError('Failed to create order.'));
  }, [addressId]);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setPaymentError('');
  };

  const handlePayment = () => {
    if (!selectedOption) {
      setPaymentError('Please select a payment option.');
      return;
    }

    const amountToPay = selectedOption === 'partial' ? 100 : order.totalPrice;

    // Redirect to Razorpay payment page
    navigate('/rasorpay', { state: { orderId: order.id, amount: amountToPay } });
  };

  if (!order) {
    return <div>Loading order details...</div>;
  }

  return (
    <div className="order-selection-container">
      <h2>Review Your Order</h2>
      <p><strong>Order Total:</strong> ₹{order.totalPrice.toFixed(2)}</p>

      <h3>Choose Payment Option:</h3>
      <div className="payment-options">
        <label>
          <input
            type="radio"
            name="payment"
            value="partial"
            onChange={handleOptionChange}
          />
          Pay ₹100 now and the rest ₹{(order.totalPrice - 100).toFixed(2)} on delivery
        </label>
        <label>
          <input
            type="radio"
            name="payment"
            value="full"
            onChange={handleOptionChange}
          />
          Pay the full amount now (₹{order.totalPrice.toFixed(2)})
        </label>
      </div>

      {paymentError && <div className="error-box">{paymentError}</div>}

      <button onClick={handlePayment} className="place-order-btn">
        Proceed to Payment
      </button>
    </div>
  );
};

export default OrderSelection;
